import React, { useState } from 'react';
import { Modal, Box, FormControl, Typography, TextField,Snackbar,Alert ,Tooltip, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { grey, red } from '@mui/material/colors';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, 
  p:4,
  outline: 'none',
  maxHeight: 'auto', 
  width: { xs: '90%', sm: '500px' }, 
};

const listatipo = [
  'Eléctrico', 'Mecánico','Soporte','ingenieria'
];

export default function Modalnewrol({ open, handleClose, refreshEquipos }) {
  const [equipoData, setequipoData] = useState({ nombre: '', descripcion: '', tipo: [] });
  const [confirmType, setConfirmType] = useState(null);
  const [error, setError] = useState(false); // Cambiado a booleano para consistencia
  const [isFocused, setIsFocused] = useState(false);
  const [isNameFocused, setIsNameFocused] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const validateAndOpenSave = () => {
    const isNombreEmpty = !equipoData.nombre.trim();
    const isDescEmpty = !equipoData.descripcion.trim();
    const istipoEmpty = equipoData.tipo.length === 0;

    if (isNombreEmpty || isDescEmpty || istipoEmpty) {
      setError(true);
    } else {
      setError(false);
      setConfirmType('save');
    }
  };

  const handleCheck = (tipo) => {
    const isChecked = equipoData.tipo.includes(tipo);
    setequipoData({
      ...equipoData,
      tipo: isChecked 
        ? equipoData.tipo.filter(p => p !== tipo) 
        : [...equipoData.tipo, tipo]
    });
  };

  const resetModal = () => {
    setequipoData({ nombre: '', descripcion: '', tipo: [] });
    setConfirmType(null);
    setError(false);
    handleClose();
  };

  const handleSubmit = async () => {
    try {
      const res = await fetch(`${BASE_URL}/equipos/nuevo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(equipoData)
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        resetModal();
        refreshEquipos();
        setSnackbar({ open: true, message: 'Equipo creado con éxito', severity: 'success' });
      } else {
        setSnackbar({ open: true, message: data.message || 'No se pudo crear el equipo', severity: 'error' });
      }
    } catch (e) { setSnackbar({ open: true, message: 'Error de conexión con el servidor', severity: 'error' }); }
  };

  if (confirmType) {
    return (
      <Modal open={open} onClose={() => setConfirmType(null)}>
        <Box sx={style}>
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography variant="h6" textAlign="start" >
              {confirmType === 'cancel' ? '¿Cancelar nuevo equipo?' : '¿Crear nuevo equipo?'}
            </Typography>
            <Typography variant="body1" color='textSecondary' >
              {confirmType === 'cancel' ? 'Los datos ingresados se perderán.¿Estás seguro que deseas cancelar?' : '¿Estás seguro que deseas crear este nuevo equipo?'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt:2 , justifyContent:'end' }}>
              <Button fullWidth 
                      variant="contained" 
                      sx={{bgcolor:grey[100], color:'black',textTransform: 'none',width: { xs: '50%', sm: '42%' }}} 
                      onClick={() => setConfirmType(null)}>
                {confirmType === 'cancel' ? 'No, continuar editando' : 'No, revisar datos'}
              </Button>
              <Button fullWidth 
                      variant="contained" 
                      sx={{ bgcolor: 'black', textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
                      onClick={confirmType === 'cancel' ? resetModal : handleSubmit}>
                      {confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  }

  const Inputstyle = {
      '& .MuiOutlinedInput-root': {
        bgcolor: '#f5f5f5',
        borderRadius: '8px',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: grey[400] },
        '&.Mui-focused fieldset': { borderColor: grey[600] },
      },
    };
  

  return (
    <>
      <Modal open={open} onClose={() => setConfirmType('cancel')}>
        <Box sx={style}>
          <Box sx={{display:'flex',gap:2,flexDirection:'column',}}>
            <Box>
              <Typography variant="h6">Crear Nuevo Equipo</Typography>
              <Typography variant="subtitle1" color='textSecondary' >Completa la información del equipo o solución</Typography>
            </Box>

            <FormControl>
              <Typography>Nombre del equipo</Typography>
              <Tooltip 
                title="Debes completar este campo" 
                open={(isNameFocused || error) && !equipoData.nombre.trim()}
                placement="top-end" 
                arrow
                componentsProps={{ tooltip: { sx: { bgcolor: red[700] } }, arrow: { sx: { color: red[700] } } }}
              >
                <TextField 
                  fullWidth
                  sx={Inputstyle} 
                  error={error && !equipoData.nombre.trim()}
                  value={equipoData.nombre}
                  onFocus={() => setIsNameFocused(true)}
                  onBlur={() => setIsNameFocused(false)}
                  onChange={(e) => setequipoData({...equipoData, nombre: e.target.value})} 
                />
              </Tooltip>
            </FormControl>
              
            <FormControl>
              <Typography>Descripción</Typography>
              <Tooltip 
                title="Debes completar este campo" 
                open={(isFocused || error) && !equipoData.descripcion.trim()}
                placement="top-end"
                arrow
                componentsProps={{ tooltip: { sx: { bgcolor: red[700] } }, arrow: { sx: { color: red[700] } } }}
              >
                <TextField  
                  variant='outlined'
                  fullWidth 
                  multiline 
                  rows={2} 
                  sx={Inputstyle}  
                  error={error && !equipoData.descripcion.trim()}
                  value={equipoData.descripcion}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  onChange={(e) => setequipoData({...equipoData, descripcion: e.target.value})} 
                  />
              </Tooltip>
            </FormControl>
            
            <FormGroup>
              <Typography variant="body1">Tipo de solución</Typography>
              <Tooltip 
                title="Debes seleccionar al menos un tipo" 
                open={error && equipoData.tipo.length === 0} 
                placement="top-end" 
                arrow
                componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
              >
                <Box sx={{ my: 1, border: `1px solid ${error && equipoData.tipo.length === 0 ? red[700] : grey[300]}`, borderRadius: '8px', p:1 }}>
                  {listatipo.map((tipo) => (
                    <Box
                      key={tipo}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        bgcolor: 'white',
                        height: '28px', 
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox 
                            size="medium" 
                            sx={{ px: 0.5 }}
                            checked={equipoData.tipo.includes(tipo)} 
                            onChange={() => handleCheck(tipo)} 
                          />
                        }
                        label={
                          <Typography variant="body1" sx={{userSelect: 'none' }}>
                            {tipo}
                          </Typography>
                        }
                        sx={{ 
                          margin: 0, 
                          width: '100%',
                          '& .MuiFormControlLabel-label': { width: '100%' } 
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </Tooltip>
            </FormGroup>

            <Box sx={{display:'flex',flexDirection:'row',justifyContent:'end'}}>
              <Button  
                variant="contained" 
                color='primary'
                sx={{bgcolor:grey[100], color:'black', width: { xs: '50%', sm: '25%' },textTransform: 'none',mr:1, '&:hover': {bgcolor: grey[200]}}} 
                onClick={() => setConfirmType('cancel')}>
                Cancelar
              </Button>
              <Button 
                variant="contained" 
                sx={{ bgcolor: 'black',ml:1, textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
                onClick={validateAndOpenSave}
              >
                Crear Equipo
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar open={snackbar.open} autoHideDuration={2500} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </>
  );
}